<ion-list lines="none" class="ion-padding-vertical">
  <ion-item lines="none">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </ion-item>
</ion-list>
